import { STORE_BYID_LIST, STORE_LIST, STORE_LIST_LOADER } from "../actions/type";

const initialState = {
  storeList: {},
  storeListLoader: false,
  storeListById:{}
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case STORE_LIST:
      return {
        ...state,
        storeList: payload,
        storeListLoader: false,
      };

    case STORE_LIST_LOADER:
      return {
        ...state,
        storeListLoader: payload,
      };
    case STORE_BYID_LIST:
      return {
        ...state,
        storeListById: payload,
      };

    default:
      return state;
  }
}
